module.exports = "/_next/static/images/landing3-tablet-e5afed1ef4df9af9109e5c9df94cd58b.png";